<div class="void-message-grid-container">
  <div class="message-column">
    <i class="oda-alert"></i>
    <p class="void-description">{{"order.item.void.des.1" | translate}}</p>
  </div>
</div>
